module.exports = __webpack_public_path__ + "img/symbol_9.b98e9205.png";